import { computed, shallowRef } from 'vue';
import type { Winner } from '@/interface/jackpot';
import { TriggerResult } from '@/interface/jackpot';
import Api from '@/libraries/api';
import { useWinner } from '@/libraries/composables/useJackpotData';
import { platform } from '@/libraries/helpers/platformHelper';
import { useRootStore } from '@/stores/rootStore';

const claimedWinner = shallowRef<Winner | null>(null);

export function useJackpotWinnerPopup() {
    const { winner } = useWinner();

    const { setTopScreenToast } = useRootStore();

    const isShowPopup = computed(() => !!winner.value && winner.value !== claimedWinner.value);

    async function closePopup() {
        const claiming = winner.value;
        if (!claiming || claiming === claimedWinner.value) return;

        claimedWinner.value = claiming;

        try {
            const result = await Api.claimJackpot(claiming.type, claiming.round);
            if (result !== TriggerResult.Success) throw new Error(`claimJackpot: ${TriggerResult[result]}`);
            platform.updateBalance();

            setTopScreenToast({
                status: 'success',
                messageKey: 'jackpot_claimSuccess',
                messagePosition: 'position-bottom',
            });
        } catch (err) {
            console.error(err);
            setTopScreenToast({
                status: 'error',
                messageKey: 'jackpot_claimError',
                messagePosition: 'position-bottom',
            });
        }
    }

    return {
        winner,
        isShowPopup,
        closePopup,
    };
}
